import React from "react";
import { FaRegEye } from "react-icons/fa";
import { EyeIconWrap } from "./styled";

const EyeIcon = ({ className, placeName = "" }) => {
  return (
    <EyeIconWrap
      className={`${className} justify-self-end max-w-[140px] eye-icon-btn flex items-center border-2 border-[#58a3a4] overflow-hidden rounded-[12px]`}
    >
      <span className="ripple-effect" />
      <div className="eye h-[26px] p-[0_7px] bg-[#58a3a4] text-white flex items-center justify-center">
        <FaRegEye className="text-lg" />
      </div>
      <strong className="p-[0_4px] text-[#58a3a4] text-[16px]">
        {placeName}, View More...
      </strong>
    </EyeIconWrap>
  );
};

export default EyeIcon;
